module.exports = __webpack_public_path__ + "img/editor.d2754b95.png";